<template>
    <div v-if="isInitialized">
        <router-view></router-view>
    </div>
</template>

<script>
import User from '@/models/user';

export default {
    computed: {
        isInitialized() {
            return this.$store.state.system.is_initialized;
        },
    },
    beforeCreate() {
        User.init();
    },
};
</script>
